/**
 * セット企画設定画面　企画商品情報取得VOクラス
 */
export class KYMW1312GetSetPlanGoodsInfoModel {
  /** 処理区分(1：設定、2：追加) */
  public accessDiv: string = <string>'';
  /** 受注コード */
  public orderCode: string = <string>'';
  /** Ｐコードリスト */
  public pCodeList: Array<any> = new Array<any>();
}
